// Phase 2 — Full-screen loading overlay. Token-styled replacement for the legacy
// antd Modal+Spin SpinLoader (docs/04 §4.6). Same usage: <LoadingOverlay loading={x} />.
import { Loader2 } from "lucide-react";
import { cn } from "lib/utils";

export interface LoadingOverlayProps {
  loading: boolean;
  /** Optional message under the spinner. */
  label?: string;
  className?: string;
}

export function LoadingOverlay({ loading, label, className }: LoadingOverlayProps) {
  if (!loading) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      className={cn("mz fixed inset-0 z-[100] flex flex-col items-center justify-center gap-3 bg-black/40", className)}
    >
      <div className="flex flex-col items-center gap-3 rounded-xl bg-card p-6 shadow-lg">
        <Loader2 className="h-7 w-7 animate-spin text-primary" />
        {label && <span className="text-sm text-muted-foreground">{label}</span>}
      </div>
    </div>
  );
}
